var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutVertical({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 9.625H16.5C17.2293 9.625 17.9288 9.91473 18.4445 10.4305C18.9603 10.9462 19.25 11.6457 19.25 12.375V16.0417C19.25 16.771 18.9603 17.4705 18.4445 17.9862C17.9288 18.5019 17.2293 18.7917 16.5 18.7917H5.5C4.77065 18.7917 4.07118 18.5019 3.55546 17.9862C3.03973 17.4705 2.75 16.771 2.75 16.0417V12.375C2.75 11.6457 3.03973 10.9462 3.55546 10.4305C4.07118 9.91473 4.77065 9.625 5.5 9.625H7.33333",
    stroke: "#03030A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7524 3.2085V14.2085",
    stroke: "#03030A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45264 6.5085L10.7526 3.2085L14.0526 6.5085",
    stroke: "#03030A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutVertical);
export default __webpack_public_path__ + "static/media/LogoutVertical.4fa59d9cd180f10d4294cbbabd1c01a2.svg";
export { ForwardRef as ReactComponent };